import { atom } from 'jotai';
import { atomEffect } from 'jotai-effect';
import { setReadingProgressItems } from '~/app/_hooks/use-local-reading-progress';
import type { ChatNovelScript } from '~/app/_types/chat-script';
import type { StoryOverview } from '~/common/types/story-overview';

// Maximum value of the shown Operation's Index
export const maximumShownOpIndexAtom = atom(0);

// Story Overview
export const storyAtom = atom<StoryOverview | undefined>(undefined);

// Story Overview
export const chatNovelScriptAtom = atom<ChatNovelScript | undefined>(undefined);

/**
 * Update ReadingProgress in LocalStorage when maximumShownOpIndexAtom is updated.
 */
export const updateSmaximumShownOpIndexAtomEffect = atomEffect((get) => {
  const story = get(storyAtom);
  const chatNovelScript = get(chatNovelScriptAtom);
  const opIndex = get(maximumShownOpIndexAtom);
  if (!story || !chatNovelScript) return;
  const isFinish = chatNovelScript.totalOpsCount <= opIndex + 1;

  setReadingProgressItems({
    storyId: story.id,
    progress: opIndex,
    isFinish: isFinish,
  });
});
